import { Box, Typography, Card } from "@material-ui/core";
import PropTypes from "prop-types";
import useStyles from "./DeviceStatCardGroup.style";

const DeviceStatCardGroup = ({ stats }) => {
  const classes = useStyles();

  const getVariantClass = (index) => {
    if (index === 0) {
      return "apple";
    }
    if (index === stats.length - 1) {
      return "silver";
    }
    if (index === 1) {
      return "gold";
    }
    return "silver";
  };

  return (
    <Box className={classes.cardContainer}>
      {stats.map(({ label, value }, index) => (
        <Box key={index}>
          <Typography variant="body2" className={classes.cardLabel}>
            {label}
          </Typography>
          <Card
            className={`${classes.card} ${
              classes.cardVariant
            } ${getVariantClass(index)}`}
          >
            <Typography variant="h4" className={classes.cardText}>
              {value != null ? value : "--"}
            </Typography>
          </Card>
        </Box>
      ))}
    </Box>
  );
};

DeviceStatCardGroup.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.number,
      cardClass: PropTypes.string.isRequired,
    })
  ),
};

export { DeviceStatCardGroup };
